// extracted by mini-css-extract-plugin
export default {"componentWrapper":"componentWrapper___njdJm","routingWrapper":"routingWrapper___VfAg7"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"componentWrapper\":\"componentWrapper___njdJm\",\"routingWrapper\":\"routingWrapper___VfAg7\"}";
        // 1793029700321
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  